module.exports = global["surveylab_monitor_mail"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./mail.ts");